// Copyright © 2021 Move Closer
import { defineComponent } from '@vue/composition-api';
import { abstractNavProps, useNav } from '../../_abstract';
import { BootstrapNavItem } from './_partials';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const BootstrapNav = defineComponent({
    name: 'BootstrapNav',
    components: { BootstrapNavItem },
    props: abstractNavProps,
    emits: ['update:activeItem'],
    setup(props, ctx) {
        const { _activeItem, activateItem, isItemActive, variantClass } = useNav(props, ctx);
        return { _activeItem, activateItem, isItemActive, variantClass };
    },
    template: `
    <nav>
      <div class="nav nav-tabs" role="tablist" :class="[{'--right' : items.length > 6 }, variantClass]">
        <div class="nav-tabs__inner">
          <BootstrapNavItem v-for="item in items" :key="item.id" v-bind="item"
                            :active="isItemActive(item.id)" @click="activateItem(item.id)" />
        </div>
      </div>
    </nav>
  `
});
